module.exports = __webpack_public_path__ + "img/thermoking-400.a4f863ac.png";